export default {
  default: () => import("/home/node/layouts/default.vue").then(m => m.default || m),
  loading: () => import("/home/node/layouts/loading.vue").then(m => m.default || m),
  rvs: () => import("/home/node/layouts/rvs.vue").then(m => m.default || m),
  uko: () => import("/home/node/layouts/uko.vue").then(m => m.default || m)
}